// @ts-ignore
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SortOptions, TripTypes } from '@model/common';
import { Months } from '@model/common/dates';
import { HYDRATE } from 'next-redux-wrapper';
import { isEqual } from 'lodash';

/* ***************** *
 *       TYPES       *
 * ***************** */
export interface NavigationState {
  selectedFilter: TripTypes;
  selectedSortOption: SortOptions;
  selectedMonth: Months;
  selectedAirport: string;
}

/* ***************** *
 *   ACTION TYPES    *
 * ***************** */
export enum NavigationActionTypes {
  SLICE_NAME = '@NAV',
  SELECTED_FILTER_OPTION = '@NAV/setTripTypeFilter',
  SELECTED_SORT_OPTION = '@NAV/setSelectedSortOption',
  SELECTED_MONTH = '@NAV/setSelectedMonth',
  SELECTED_AIRPORT = '@NAV/setSelectedAirport'
}

/* ***************** *
 *   INITIAL STATE   *
 * ***************** */
export const NAVIGATION_INITIAL_STATE: NavigationState = {
  selectedFilter: TripTypes.HOLIDAYS,
  selectedSortOption: SortOptions.SORT_ALPHABETICAL,
  selectedMonth: Months.JAN,
  selectedAirport: 'LON'
};

/* ***************** *
 *     HELPERS       *
 * ***************** */
const getValidTripType = (tripType: TripTypes) => (tripType === TripTypes.ADD_ONS ? TripTypes.HOLIDAYS : tripType);

/* ***************** *
 *      SLICE        *
 * ***************** */
export const navigationSlice = createSlice({
  name: NavigationActionTypes.SLICE_NAME,
  initialState: NAVIGATION_INITIAL_STATE,
  reducers: {
    setTripTypeFilter: (state: { selectedFilter: TripTypes }, action: PayloadAction<string>) => {
      state.selectedFilter = getValidTripType(action.payload as TripTypes) || null;
    },
    setSelectedSortOption: (state: { selectedSortOption: SortOptions }, action: PayloadAction<string>) => {
      state.selectedSortOption = action.payload as SortOptions;
    },
    setSelectedMonth: (state: { selectedMonth: Months }, action: PayloadAction<string>) => {
      state.selectedMonth = action.payload as Months;
    },
    setSelectedAirport: (state: { selectedAirport: any }, action: PayloadAction<string>) => {
      state.selectedAirport = action.payload;
    }
  },
  extraReducers: (builder: any) => {
    builder.addCase(HYDRATE, (state, action: any) => {
      if (isEqual(state, NAVIGATION_INITIAL_STATE)) {
        return action.payload?.navigation || state;
      }
      return state;
    });
  }
});

export const { setTripTypeFilter, setSelectedSortOption, setSelectedMonth, setSelectedAirport } =
  navigationSlice.actions;

export const navigationReducer = navigationSlice.reducer;
